import React from "react";
import { GlobalContext } from "../../context/GlobalState";
import { CSVLink } from "react-csv";
import {
  Paper, Grid, Typography, Box, Button, MenuItem, FormControl, Select,
  InputLabel, CircularProgress, TableHead, Dialog, Table, DialogActions,
  DialogContent, DialogContentText, DialogTitle, TableBody, TableCell, TableRow
  } from "@material-ui/core";

import moment from "moment";

export default function AddressDump() {
  const [back, setBack] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [type, setType] = React.useState("parent");
  const [dbutton, setDbutton] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [status, setStatus] = React.useState("Active");
  const [centercode, setCentercode] = React.useState("All");
  const { allcentercode, getCenterCodeDetails } = React.useContext( GlobalContext);
  const {
    addressData,
    getAddressDetails,
    err
  } = React.useContext(GlobalContext);

  const handleClose = () => {
    setOpen(false);
    setBack(true);
  };

  const changeCenterCode = (e) => {
    setCentercode(e.target.value);
  };

  

React.useEffect(() => {
    getCenterCodeDetails();
  }, []);

  const changeStatus = (e) => {
    setStatus(e.target.value);
  };

  const onChangeType = e => {
    const value = e.target.value ? e.target.value : "";
    setType(value);
    console.log(value);
  };


  const headCells = [
    { id: 'fname', numeric: false, label: "First Name" },
    { id: 'lname', numeric: false, label: "Last Name" },
    { id: 'centerCode', numeric: false, label: "Center Code" },
    { id: 'add1', numeric: false, label: "Address 1" },
    { id: 'add2', numeric: false, label: "Address 2" },
    { id: 'phone', numeric: false, label: "Phone Number" },
    { id: 'city', numeric: false, label: "City" },
    { id: 'state', numeric: false, label: "State" },
    { id: 'pin', numeric: false, label: "Pin" }
  ];

  const onSubmit = async e => {
    setDbutton(true);
    setLoading(true);
    e.preventDefault();
    const summary = {
      centercode: centercode,
      type: type,
      status: status
    };
    await getAddressDetails(summary);
    setDbutton(false);
    setLoading(false);
  };
  let filterData = addressData.filter((item)=>(
    item[0] !== "First Name"
  ))
  
  const csvData = addressData;

  return (
    <React.Fragment>
      <Box boxShadow={3} mb={1}>
        <form onSubmit={onSubmit}>
          <Grid container component={Paper}>
            <Grid
              item
              xs={12}
              style={{ background: "antiquewhite", marginBottom: "16px" }}
            >
              <Box p={2}>
                <Typography variant="h6">Address Dump</Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={3}>
              <Box px={1} mt={2} pl={2}>
                <FormControl variant="outlined" fullWidth required>
                  <InputLabel id="type">Type</InputLabel>
                  <Select
                    labelId="type"
                    value={type}
                    onChange={onChangeType}
                    name="type"
                    label="Type"
                  >
                    <MenuItem value={"centerhead"}>Center Head</MenuItem>
                    <MenuItem value={"faculty"}>Faculty</MenuItem>
                    <MenuItem value={"parent"}>Parent</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>


    <Grid item xs={12} sm={3}>
        <Box px={2} mt={2}>
          <FormControl variant='outlined' required fullWidth>
            <InputLabel id='demo-simple-select-filled-label12' required>
              Status
            </InputLabel>
            <Select
              labelId='demo-simple-select-filled-label12'
              id='demo-simple-select-filled12'
              value={status}
              onChange={changeStatus}
              name='Status'
              label='Status'
            >
                <MenuItem key='all' value='All'>All</MenuItem>
                <MenuItem value={"Active"}>Active</MenuItem>
                <MenuItem value={"Others"}>Others</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Grid>

      <Grid item xs={12} sm={3}>
        <Box px={2} mt={2}>
          <FormControl variant='outlined' required fullWidth>
            <InputLabel id='demo-simple-select-filled-label12' required>
              Center Code
            </InputLabel>
            <Select
              labelId='demo-simple-select-filled-label12'
              id='demo-simple-select-filled12'
              value={centercode}
              onChange={changeCenterCode}
              name='centerCode'
              label='Center Code'
            >
                <MenuItem key='all' value='All'>
                  All
                </MenuItem>
              {allcentercode.map((code) => (
                <MenuItem key={code._id} value={code.centerCode}>
                  {code.centerCode}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Grid>

            <Grid item xs={12}>
            <Box p={2}>
            <Button style={{float:"right"}}
                  type="submit"
                  size="large"
                  variant="contained"
                  color="primary"
                >
                  {loading ? (
                    <>
                      Loading
                      <CircularProgress
                        style={{ color: "#fff", marginLeft: "15px" }}
                        size={20}
                      />
                    </>
                  ) : (
                    "Generate Address"
                  )}
                </Button>
              <Button
                disabled={dbutton}
                id="download"
                size="large"
                variant="contained"
                color="primary"
              >
                <CSVLink
                  data={csvData}
                  filename={`address-${type}-${status}-${moment().format("DD-MM-YYYY")}.csv`}
                  style={{ textDecoration: "none", color: "#fff" }}
                >
                  Download{" "}
                </CSVLink>
              </Button>
              
            </Box>
            </Grid>
          </Grid>
        </form>
        {filterData.length ?
        <div style={{margin: "15px", border: "1px solid", borderRadius: "6px"}}>
        <Table style={{backgroundColor: "#fff"}}>
        <TableHead style={{backgroundColor: "#3f51b5", color: "#fff"}}>
      <TableRow style={{color: "#fff"}}>
      {headCells.map((headCell) => (
          <TableCell style={{color: "#fff"}}
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'center'}
            padding={headCell.disablePadding ? 'none' : 'default'}
          >        
          {headCell.label}
          </TableCell>
        ))}

      </TableRow>
      </TableHead>
      <TableBody>
      {filterData.map((value, index)=>{
  return (
  <TableRow key={index+1}>
  <TableCell align="center">{value[0] ? value[0] : '-'}</TableCell>
  <TableCell align="center">{value[1] ? value[1] : '-'}</TableCell>
  <TableCell align="center">{value[2] ? value[2] : '-'}</TableCell>
  <TableCell align="center">{value[3] ? value[3] : '-'}</TableCell>
  <TableCell align="center">{value[4] ? value[4] : '-'}</TableCell>
  <TableCell align="center">{value[5] ? value[5] : '-'}</TableCell>
  <TableCell align="center">{value[6] ? value[6] : '-'}</TableCell>
  <TableCell align="center">{value[7] ? value[7] : '-'}</TableCell>
  <TableCell align="center">{value[8] ? value[8] : '-'}</TableCell>
  </TableRow>  
  );
})}
</TableBody>
</Table></div> : null }
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          align="center"
          style={{ background: "antiquewhite" }}
          id="responsive-dialog-title"
        >
          {err ? err : "Summary report is generated"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Button onClick={handleClose} variant="contained" color="primary">
            Back
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
